import type { Maybe } from '@adornis/base/utilTypes';
import { acss } from '@adornis/chemistry/directives/acss';
import { stateful } from '@adornis/functional-lit/stateful';
import { useQuery } from '@adornis/functional-lit/use-query';
import { html, nothing } from 'lit';
import { getFolderPath } from '../api/getFolderPath';
import { arrowRightIcon } from './icons/arrowRightIcon';

export const MediaBreadcrumb = stateful(
  ({
    parentFolderID,
    onBreadcrumbClick,
  }: {
    parentFolderID: Maybe<string>;
    onBreadcrumbClick: (folderID: Maybe<string>) => void;
  }) => {
    const isHome = parentFolderID === null || !parentFolderID;
    const { value: folderPath } = useQuery(() => getFolderPath(parentFolderID)({ name: 1, _id: 1 }), [parentFolderID]);
    if (!folderPath) return nothing;

    const colors = {
      currentPath: '#5d5d5f',
      parentPath: '#0099ff',
    };

    const renderItem = (id: Maybe<string>, name: string, appendIcon: boolean = true) => {
      return html`
        <d-text
          data-ds-dropzone=${appendIcon}
          data-media-id=${id ?? ''}
          small
          ${acss({
            color: parentFolderID === id ? colors.currentPath : colors.parentPath,
            '&:hover':
              parentFolderID !== id ? { cursor: 'pointer', textDecoration: 'underline', color: colors.parentPath } : {},
          })}
          @click=${() => onBreadcrumbClick(id)}
        >
          ${name}
        </d-text>
        ${appendIcon ? arrowRightIcon({ color: colors.currentPath }) : nothing}
      `;
    };

    if (isHome) return renderItem(null, 'Home', false);

    return html`
      <d-flex horizontal crossaxis-center space="sm">
        ${renderItem(null, 'Home', true)}
        ${folderPath.map((folder, index) => renderItem(folder._id, folder.name, index !== folderPath.length - 1))}
      </d-flex>
    `;
  },
);
